export default "__VITE_ASSET__fPalPqrR__"